
const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartModalClose: '.js-ajax-cart-modal-close', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.cart-items-listing', 
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-add-to-cart', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.js-ajax-cart-counter', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {
                    
    addToCart[i].addEventListener('click', function(event) {
        
        event.preventDefault();
     console.log( $(this).parents().find('.product-form').attr('id'));
        const formID = $('.product-form').attr('id');
        addProductToCart(formID);
      
    });

}

function addProductToCart(formID) {
   console.log( $('#' + formID).serialize()); 
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });
  
}

function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = 'Cart is empty';
                checkoutButton.classList.add('is-hidden');
            } else {
                renderCart(cart);
                checkoutButton.classList.remove('is-hidden'); 
              	
            }
        },
    });
}

function changeItem(line, callback) {
//  console.log(line);
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart) {
  $('#cart-count').text(cart.item_count);
//     console.log('items in the cart?', cart.item_count);
}

function addToCartOk(product) {
//   cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
   openCartOverlay();
    fetchCart();	
}

function removeProductFromCart() {
//     cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
//     cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
//     openAddModal();
    openCartOverlay();
}

function renderCart(cart) {  

  $('#total-price').text(Shopify.formatMoney(cart.total_price,theme.moneyFormat));
    clearCartDrawer();

    cart.items.forEach(function(item, index) {

      var size = '';
      var color= '';
      var compareAtPrice;
      item.options_with_values.forEach(function(items, index) {
          if(items.name == 'Size'){
            size=items.value;                  	
          }
          if(items.name == 'Color'){
            color =items.value;                  	
          }
      });
      $.ajax({ 
        url: '/products/' + item.handle + '.js', 
        dataType: 'json',
        async: false, 
        success: function(product){  
          compareAtPrice = product.compare_at_price
        } 
      });

      
        var  productImage = '<div class="item-left"><img class="ajax-cart-item__image" src="' + item.image + '" ></div>';
        var  productTitle = '<div class="item-right"><div class="top-detail"><div class="ajax-cart-item__title">' + item.title + '</div>';      
      var productPrice = '<div class="ajax-cart-item__price">';
      var priceClass = '';
      if(compareAtPrice != null){        
         	priceClass = "sell-price";
        	productPrice = productPrice + '<s class="price-item price-item--regular">'+Shopify.formatMoney(compareAtPrice,theme.moneyFormat) +'</s>';
      }
      productPrice = productPrice +'<span class="'+priceClass+'">'+Shopify.formatMoney(item.line_price,theme.moneyFormat) + '</span></div>';

      if (size) {        
      	var productSize = '<div class="ajax-cart-item__size">Size:' + size + '</div>';
      }
      if (color) {        
      	var productColor = '<div class="ajax-cart-item__color">Color:' + color + '</div>';
      }
      
      var productRemove = '<div class="bottom-detail" data-line="' + Number(index + 1) + '"><div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"><a class="grayborder-btn">Remove</a></div>';


      var concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + productImage  + productTitle + productPrice ;
      if (size) {
      		concatProductInfo = concatProductInfo + productSize;
      }
      if (color) {
      		concatProductInfo = concatProductInfo + productColor;
      }
		concatProductInfo = concatProductInfo +'</div>'+ productRemove + '</div>';
        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
    });

    removeFromCart = document.querySelectorAll(defaults.removeFromCart);

    for (let i = 0; i < removeFromCart.length; i++) {      
        removeFromCart[i].addEventListener('click', function() {
            const line = this.parentNode.getAttribute('data-line');
            changeItem(line);
        });
    }

}

function priceConvertor(price) {
  	console.log('Before fun Price'+price);
	 var price1 = Shopify.formatMoney(price);
	 price1.replace('$','');
  	console.log('fun Price'+price1);
	 return price1;
}

function openCartDrawer() {
//   console.log('open');
    cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openCartOverlay() {
//   console.log('overlay');
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}



cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
//     closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function(event) {
    event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();	
  	
});

document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});
